<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex items-center">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block w-full md:w-1/2 md:mx-auto my-5 mx-3 h-full max-w-screen-sm m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal">
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-5 px-5 md:px-8">
                <h2 class="text-xl text-brand-black">Why we are asking for this information</h2>

                <div class="flex flex-col py-5">
                  <p>
                    Your ID and account verification is required for compliance purposes to help
                    avoid criminal activity and money laundering. The name you send us should be the
                    full legal name of the person or company receiving the transfers. If an
                    individual account is used, it should match the SSN. If a company name is used,
                    it should match the name for the EIN.
                  </p>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {
    closeModal() {
      this.$emit("close")
    }
  }
}
</script>
<style scoped></style>
